import DatePicker from "react-datepicker";

export default function DateRangeInput({
  id,
  startDate,
  endDate,
  onChange,
  reference,
  minDate,
  maxDate,
  isReadOnly,
}) {
  return (
    <DatePicker
      showPopperArrow={false}
      id={id}
      autoComplete="off"
      selectsRange={true}
      startDate={startDate}
      endDate={endDate}
      disabled={isReadOnly}
      onChange={onChange}
      minDate={minDate}
      maxDate={maxDate}
      isClearable
      placeholderText="Select date range"
      wrapperClassName="date-picker"
      calendarClassName="calendar-container"
      popperClassName="popper-container"
      popperModifiers={[
        {
          name: "preventOverflow",
          options: {
            boundary: reference.current, // align calendar to edge of date card
          },
        },
      ]}
    />
  );
}
